<template>
  <div
    class="ce-documentResult-selectAllCta"
    :class="{'ce-documentResult-selectAllCta--disabled': isSelectAllDisabled}">
    <span class="label">
      {{ $t('productSheets.selectAll.label') }}
    </span>

    <tooltip
      v-if="isSelectAllDisabled"
      :content="$t('productSheets.selectAll.disabledTooltip', { limit: selectAllProductsLimit })">
      <checkbox
        class="ce-checkbox--small"
        id="selectAllCheckbox"
        :value="allSelected"
        disabled
        :show-label="false" />
    </tooltip>

    <checkbox
      v-else
      class="ce-checkbox--small"
      id="selectAllCheckbox"
      :value="allSelected"
      @input="handleInput"
      :show-label="false" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isSelectAllDisabled', 'selectAllProductsLimit', 'results', 'basketSize', 'uniqueLoadedAssetsCount']),
    allSelected() {
      return this.basketSize === this.uniqueLoadedAssetsCount;
    }
  },
  methods: {
    ...mapActions(['selectAll', 'clearBasket']),
    async handleInput() {
      if (this.allSelected) {
        this.clearBasket();
      } else {
        await this.selectAll();
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';
.ce-productSheets .ce-documentResults-headerRow .ce-documentResult-selectAllCta {
  font-weight: normal;
  display: flex;
  align-items: center;

  span.label {
    .ms(-1);
    margin-right: @space-1;
    font-weight: bold;
  }

  &.ce-documentResult-selectAllCta--disabled {
    span.label {
      opacity: 0.5;
    }
  }
}
</style>
